import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FileDetail,
  FileDetailTotals,
  calculateFileDetailTotals,
} from '../../../../../core/models/file-detail.model';
import {
  RequestStatus,
  RequestStatusLabels,
} from '../../../../../core/enums/request-status.enum';

@Component({
  selector: 'app-file-details-grid',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './file-details-grid.component.html',
  styleUrls: ['./file-details-grid.component.scss'],
})
export class FileDetailsGridComponent {
  @Input() fileDetails: FileDetail[] = [];
  @Input() canOpenFileDetails = false;
  @Input() showReadyToProcess = false;
  @Output() fileRowClicked = new EventEmitter<FileDetail>();

  readonly statusLabels = RequestStatusLabels;

  get totals(): FileDetailTotals {
    return calculateFileDetailTotals(this.fileDetails);
  }

  getStatusLabel(status: RequestStatus): string {
    return RequestStatusLabels[status] || 'Unknown';
  }

  getStatusClass(status: RequestStatus): string {
    switch (status) {
      case RequestStatus.Pending:
        return 'status-pending';
      case RequestStatus.InProgress:
        return 'status-in-progress';
      case RequestStatus.Completed:
        return 'status-completed';
      case RequestStatus.Cancelled:
        return 'status-cancelled';
      case RequestStatus.OnHold:
        return 'status-on-hold';
      case RequestStatus.Error:
        return 'status-error';
      case RequestStatus.Open:
        return 'status-in-progress';
      case RequestStatus.Sent:
        return 'status-completed';
      case RequestStatus.Received:
        return 'status-in-progress';
      case RequestStatus.Printed:
        return 'status-completed';
      case RequestStatus.Canceled:
        return 'status-cancelled';
      default:
        return '';
    }
  }

  formatBooleanYes(): string {
    return 'Yes';
  }

  formatBooleanNo(): string {
    return 'No';
  }

  onFileRowClick(file: FileDetail): void {
    if (!this.canOpenFileDetails) {
      return;
    }
    this.fileRowClicked.emit(file);
  }
}
